import { render, staticRenderFns } from "./folder_breadcrumbs.vue?vue&type=template&id=1b582ce7&scoped=true&"
import script from "./folder_breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./folder_breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./folder_breadcrumbs.vue?vue&type=style&index=0&id=1b582ce7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b582ce7",
  null
  
)

export default component.exports